import { ButtonSize, tComponent, Nullable } from '@mobalytics/shared';
import { css } from '@emotion/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CDN_URL } from '../../../../config';
import { CongratulationThankYouLayout } from '../../../../ui/layout/congratulation-thank-you-layout/congratulation-thank-you-layout.component';
import { AccountsButton } from '../../../../ui/buttons/accounts-button/accounts-button.component';
import { TreasuryPaymentsProduct } from '../../../../__generated/treasury/types';

interface Props {
  planType: Nullable<TreasuryPaymentsProduct>;
  onClick: () => void;
  className?: string;
}

export const Diablo4ThankYou: React.FC<Props> = (props: Props) => {
  const { planType, onClick, className } = props;
  const { t } = useTranslation();
  const title = (
    <div>
      <div>
        {tComponent(`Congrats, you've fully unlocked the Build Tracker and {{ plus }}`, {
          plus: <span css={plusCss}>{t('Mobalytics+')}</span>,
        })}
      </div>
      <div>{t(`Thank you for your support!`)}</div>
    </div>
  );
  const imgSrc = `${CDN_URL}/assets/diablo-4/videos/promo/congrats_animated.avif`;
  return (
    <CongratulationThankYouLayout title={title} imgSrc={imgSrc} className={className}>
      <AccountsButton analyticsButtonName={'Start climbing'} onClick={onClick} size={ButtonSize.H40}>
        {planType === TreasuryPaymentsProduct.PLUS && t('Let’s play')}
        {planType === TreasuryPaymentsProduct.AD_FREE && t('back to mobalytics')}
      </AccountsButton>
    </CongratulationThankYouLayout>
  );
};

const plusCss = css`
  color: var(--general-orange-200);
`;
